import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, fmtErr, img, money } from "@/lib/api";
import { ClaimStatus } from "@/pages/Account";
import { selectCls } from "./ListingsTab";

const ClaimRow = ({ c, reload }) => {
  const [note, setNote] = useState(c.seller_note || "");
  const update = async (body, msg) => {
    try { await api.patch(`/admin/claims/${c.id}`, body); toast.success(msg); reload(); } catch (e) { toast.error(fmtErr(e)); }
  };
  return (
    <li className="grid gap-5 py-6 md:grid-cols-12" data-testid={`admin-claim-${c.id}`}>
      <div className="flex gap-4 md:col-span-4">
        <img src={img(c.product_image)} alt="" className="h-20 w-16 shrink-0 object-cover" />
        <div className="min-w-0">
          <p className="truncate text-[#f3eefc]">{c.product_title}</p>
          <p className="font-mono-j text-xs text-[#a78bce]">{money(c.product_price)} · {new Date(c.created_at).toLocaleDateString("en-CA")}</p>
          <div className="mt-2"><ClaimStatus s={c.status} /></div>
        </div>
      </div>
      <div className="space-y-1 text-sm text-[#cbbbe6] md:col-span-4">
        <p className="text-[#f3eefc]">{c.name}</p>
        <p>{c.email}{c.phone ? ` · ${c.phone}` : ""}{c.instagram ? ` · ${c.instagram}` : ""}</p>
        <p>{c.address}</p>
        <p>{c.fulfillment === "Pickup" ? "Local pickup" : "Ship across Canada"}</p>
        {c.message && <p className="italic">“{c.message}”</p>}
      </div>
      <div className="space-y-3 md:col-span-4">
        <div className="flex gap-2">
          <select value={c.status} onChange={(e) => update({ status: e.target.value }, `Claim ${e.target.value}`)} className={`${selectCls} flex-1`} data-testid={`admin-claim-status-${c.id}`}>
            {["Pending", "Contacted", "Reserved", "Completed", "Cancelled"].map((s) => <option key={s}>{s}</option>)}
          </select>
          <a href={`mailto:${c.email}?subject=${encodeURIComponent(`Your claim: ${c.product_title}`)}`} className="grid place-items-center rounded-sm border border-[#3b1d63] px-3 text-[#d8b4fe] hover:border-[#a855f7]" data-testid={`admin-claim-email-${c.id}`} aria-label="Email buyer"><Mail className="h-4 w-4" /></a>
        </div>
        <textarea value={note} onChange={(e) => setNote(e.target.value)} onBlur={() => note !== (c.seller_note || "") && update({ seller_note: note }, "Note saved")} rows={2} placeholder="Private note (saved automatically)" className={`${selectCls} w-full resize-none`} data-testid={`admin-claim-note-${c.id}`} />
      </div>
    </li>
  );
};

export const ClaimsTab = ({ claims, reload }) => !claims.length
  ? <p className="py-16 text-center text-[#cbbbe6]" data-testid="admin-claims-empty">No claims yet.</p>
  : <ul className="divide-y divide-[#281245] border-y border-[#281245]">{claims.map((c) => <ClaimRow key={c.id} c={c} reload={reload} />)}</ul>;
